import { useEffect, useState } from "react";

import { NotionDatabase, useNotionDatabase } from "dev";
import { ScrollView } from "react-native";

import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus } from "@/src/types";

const DB_ID = "8c4fe0fab8f34935930d914dbff0ae7a";

type NotionExample = {
  uuid: string;
  tstamp: string;
  status: string;
  substatus: string;
};

type NotionError = {
  order: NotionExample;
  newOrder: DeliveryStatus;
};

function buildOrderExamples(notionResults: NotionDatabase) {
  return notionResults
    .map((result) => {
      return {
        uuid: result["Order UUID"],
        tstamp: result["Order Timestamp"],
        status: result["Status"],
        substatus: result["Substatus"],
      } as NotionExample;
    })
    .filter((order) => order.uuid && order.tstamp);
}

export default function ExamplesAsJson() {
  const [data, setData] = useState<DeliveryStatus[]>([]);
  const [errors, setErrors] = useState<NotionError[]>([]);

  const db = useNotionDatabase(DB_ID);

  useEffect(() => {
    if (!db) return;

    const newData: DeliveryStatus[] = [];
    const newErrors: NotionError[] = [];

    const promises = buildOrderExamples(db).map((order) =>
      fetchDeliveryStatus(order).then((newOrder) => {
        if (newOrder.tracking_history) {
          newData.push(newOrder);
        } else {
          newErrors.push({ order, newOrder });
        }
      })
    );

    Promise.all(promises).then(() => {
      setData(newData);
      setErrors(newErrors);
    });
  }, [db?.length]);

  return (
    <ScrollView>
      <h1>Errors: {errors.length} </h1>
      <pre>{JSON.stringify(errors, null, 2)}</pre>

      <h1>Successes: {data.length} </h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </ScrollView>
  );
}
